module.exports = __webpack_public_path__ + "static/media/42.57f7400d.JPG";